export function sortByCriteria<T>(items: T[], criteria: (item: T) => unknown, ascending = true): T[] {
  return [...items].sort((a, b) => {
    const valueA = criteria(a);
    const valueB = criteria(b);

    // Handle strings with localeCompare
    if (typeof valueA === 'string' && typeof valueB === 'string') {
      return ascending ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
    }

    // Handle numbers and dates
    if (typeof valueA === 'number' && typeof valueB === 'number') {
      if (valueA < valueB) return ascending ? -1 : 1;
      if (valueA > valueB) return ascending ? 1 : -1;
    }

    if (valueA instanceof Date && valueB instanceof Date) {
      if (valueA < valueB) return ascending ? -1 : 1;
      if (valueA > valueB) return ascending ? 1 : -1;
    }

    return 0;
  });
}
